import { Platform, StyleSheet } from 'react-native';
import theme from '../../common/theme';
import { ThemeColors } from '../../common/theme-colors';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'row',
    },
    lhs: {
      flex: 1,
      paddingHorizontal: 20,
      backgroundColor: colors.elevation0,
    },
    listWrapper: {
      flex: 1,
    },
    list: {
      flex: 1,
      ...(Platform.OS === 'web' && { transform: 'none' }),
    },
    mask: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
    },
    listContent: {
      rowGap: 32,
      paddingVertical: 40,
      paddingHorizontal: 20,
    },
    orderNote: {
      fontSize: 16,
      lineHeight: 22,
      color: colors.focus,
      fontFamily: theme.fonts.medium,
    },
  });
